
import { Component, Vue } from 'vue-property-decorator'
import { useModule } from 'vuex-simple'
import VueElementLoading from 'vue-element-loading'

import { StepFourRequest } from '@/api/modules/auth'
import AuthModule from '@/store/modules/AuthModule'

@Component({
  components: {
    VueElementLoading
  }
})
export default class StepFourForm extends Vue {
  private authStore = useModule<AuthModule>(this.$store, ['auth'])
  private isLoading: boolean = false

  private phoneCode: string | null = null

  private async onSubmit (): Promise<void> {
    if (!this.phoneCode) {
      return this.$notify({
        title: 'Form Error',
        text: 'You must supply the Phone Code',
        type: 'error'
      })
    }

    if (!this.authStore?.token) {
      return this.$notify({
        title: 'Form Error',
        text: 'You must have a token to perform this action',
        type: 'error'
      })
    }

    const request: StepFourRequest = {
      jwt: this.authStore?.token,
      phoneCode: this.phoneCode
    }

    try {
      this.isLoading = true
      await this.authStore?.sendStepFourRequest(request)
      this.$router.push({ name: 'Opt Out Thank You' })
    } catch (e) {
      this.$notify({
        title: 'Form Error',
        text: e.message,
        type: 'error'
      })
    } finally {
      this.isLoading = false
    }
  }

  private onRestart (): void {
    sessionStorage.clear()
    this.$router.push({
      name: 'Opt Out Step One'
    })
    location.reload()
  }

  private get canSubmit (): boolean {
    return Boolean(this.phoneCode)
  }
}
